<template>
	<div class="plugInStyle">
		<el-row>
			<el-col :span="23">
				<div class="row_body">
					<div class="row_title">位置设置</div>
					<plugStyle
						:isPlugIn="true"
						:bottomDistance="bottomDistance"
						:position="position"
						@changebasic="saveBasic"
					></plugStyle>
				</div>
				<div class="row_body">
					<div class="row_title">样式设置</div>
					<styleConfig
						:bootTips="bootTips"
						:closeLink="closeLink"
						:colour="colour"
						:colourType="colourType"
						:expandFlag="expandFlag"
						:expandLink="expandLink"
						:floatingTips="floatingTips"
						@changebasic="saveBasic"
					></styleConfig>
				</div>
				<div class="row_body channels">
					<div class="row_title">渠道设置</div>
					<channelsConfig :channelList="channelList" @changebasic="saveBasic"></channelsConfig>
				</div>
			</el-col>
		</el-row>

		<!-- 样式预览 -->
		<stylePreview :configInfo="configInfo"></stylePreview>
	</div>
</template>

<script>
import plugStyle from '@/backend/pages/socialMedia/plugStyle.vue';
import styleConfig from '@/backend/pages/socialMedia/styleConfig.vue';
import channelsConfig from '@/backend/pages/socialMedia/channelsConfig.vue';
import stylePreview from '@/backend/pages/socialMedia/stylePreview.vue';

import chat from '@/backend/services/account/chat.js';
import channelsConfigList from './js/channelsList.js';

import closeLinkSvg from '!!raw-loader!./defaultSvg/closeLink.svg';
import expandLinkSvg from '!!raw-loader!./defaultSvg/expandLink.svg';

export default {
	name: 'plugInStyle',
	props: ['configInfo'],
	components: {
		plugStyle,
		styleConfig,
		channelsConfig,
		stylePreview,
	},
	data() {
		return {
			pluginsData: {},
			channelList: [],
			bootTips: null, //引导点击提示文本
			closeLink: null, //关闭图标链接
			colour: null, //颜色值
			colourType: null, //颜色类型(1:主题色;2:自定义;)
			bottomDistance: null, //距离底部距离
			expandFlag: null, //是否展开(0否;1是;)
			expandLink: null, //展开图标链接
			floatingTips: null, //鼠标悬浮提示文本
			position: null, // 显示位置(1:左;2:右;)
			id: null, // 插件信息主键ID
			isSwitch: true, // 第一次调用判断标识
		};
	},
	computed: {
		getserviceId: function () {
			let serviceId = this.$route.query.serviceSiteId;
			return serviceId;
		},
		getcustomerId: function () {
			let customerId = this.$route.query.customerId;
			return customerId;
		},
	},
	watch: {
		configInfo: {
			handler(val) {
				this.getdatacollect(val);
			},
			immediate: true,
			deep: true,
		},
	},
	methods: {
		// 获取即时聊天配置信息
		async getdatacollect(val) {
			let { isSwitch } = this;

			let { fbConfigPluginsVO, fbConfigChannelVOList } = val || {};

			const {
				bootTips = '', // 引导点击提示文本
				closeLink = '', // 关闭图标链接
				colour = '', // 颜色值
				colourType = 1, // 颜色类型(1:主题色;2:自定义;)
				distance = 10, // 距离底部距离
				expandFlag = 0, // 是否展开(0否;1是;)
				expandLink = '', // 展开图标链接
				floatingTips = '', // 鼠标悬浮提示文本
				showPosition = 1, // 显示位置(1:左;2:右;)
				id = '', // 插件信息主键ID
			} = fbConfigPluginsVO || {};

			// 更新状态
			this.pluginsData = fbConfigPluginsVO || {};
			this.channelList = fbConfigChannelVOList || [];

			this.bootTips = bootTips;
			this.closeLink = closeLink;
			this.colour = colour;
			this.colourType = colourType;
			this.bottomDistance = distance;
			this.expandFlag = expandFlag;
			this.expandLink = expandLink;
			this.floatingTips = floatingTips;
			this.position = showPosition;
			this.id = id;

			// 根据条件调用保存逻辑
			if (isSwitch && val) this.saveDefaultBasic(val);
		},

		// 位置设置及样式设置保存修改
		async saveBasic(
			{
				weizhi,
				juli,
				bootTips,
				closeLink,
				colour,
				colourType,
				expandFlag,
				expandLink,
				floatingTips,
				channelList,
			},
			reset
		) {
			let { configInfo, pluginsData, id } = this;
			let { fbConfigChannelVOList } = configInfo;

			const Obj = {
				showPosition: weizhi,
				distance: juli,
				bootTips,
				closeLink,
				colour,
				colourType,
				expandFlag,
				expandLink,
				floatingTips,
			};

			// 过滤 undefined 的字段
			let filteredObj = Object.fromEntries(
				Object.entries(Obj).filter(([_, value]) => value !== undefined)
			);

			let fbConfigChannelDTOList = channelList || fbConfigChannelVOList;
			let configInfoCopy = _.cloneDeep(configInfo);
			delete configInfoCopy.fbConfigChannelVOList;
			delete configInfoCopy.fbConfigPluginsVO;

			try {
				let res = await chat.getfabasic({
					...configInfoCopy,
					fbConfigPluginsDTO: {
						...pluginsData,
						...filteredObj,
						id,
					},
					fbConfigChannelDTOList,
					serviceSiteId: this.getserviceId,
					customerId: this.getcustomerId,
				});

				if (res.data === 'success') {
					this.success('已自动保存，发布后生效！');
				} else {
					this.fail('保存失败，请重新编辑！');
				}

				this.emitData();
				if (reset) reset();
			} catch (error) {
				console.error(error);
				this.emitData();
				if (reset) reset();
			}
		},

		// 默认配置的保存修改
		async saveDefaultBasic(val) {
			let { fbConfigPluginsVO: pluginsData, fbConfigChannelVOList: channelList } = val;
			const {
				showPosition = 1,
				distance = 10,
				bootTips = '',
				closeLink,
				colour = '',
				colourType = 1,
				expandFlag = 0,
				expandLink,
				floatingTips = '',
				id = '',
			} = pluginsData || {};

			channelList = channelList || [];

			let fbConfigChannelDTOList =
				channelList.length > 0
					? channelList.map(item => {
							let config = channelsConfigList.find(_item => _item.type === item.type) || {};
							return {
								...config,
								...item,
								iconLink: item.iconLink || config.defaultSvg,
							};
					  })
					: channelsConfigList.map(item => ({
							...item,
							iconLink: item.iconLink || item.defaultSvg,
							openFlag: 0,
					  }));

			const fbConfigPluginsDTO = {
				bootTips,
				closeLink: closeLink || closeLinkSvg,
				colour,
				colourType,
				distance,
				expandFlag,
				expandLink: expandLink || expandLinkSvg,
				floatingTips,
				showPosition,
				id,
			};

			// 去除无用属性
			const { fbConfigChannelVOList, fbConfigPluginsVO, ...rest } = val;

			try {
				await chat.getfabasic({
					...rest,
					fbConfigPluginsDTO,
					fbConfigChannelDTOList,
					serviceSiteId: this.getserviceId,
					customerId: this.getcustomerId,
				});
				this.isSwitch = false;
				this.emitData();
			} catch (error) {
				this.isSwitch = false;
				this.emitData();
			}
		},
		// 提交数据
		emitData() {
			this.$emit('emitData');
		},
		success: function (str) {
			this.$message({
				showClose: true,
				message: str,
				type: 'success',
			});
		},
		fail: function (str) {
			this.$message({
				showClose: true,
				message: str,
				type: 'error',
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.plugInStyle {
	box-shadow: 0 4px 4px 0 rgba(67, 93, 255, 0.05);
	border-radius: 4px;
	background-color: #fff;
	padding: 30px 40px;

	.row_body {
		.row_title {
			font-weight: 500;
			font-size: 17px;
			color: #333333;
			font-style: normal;
		}

		::v-deep .plugStyle {
			height: auto;
			margin-bottom: 20px;

			.leftdiv {
				padding: 10px 0 0 0;
				width: auto;
				float: none;

				.el-row {
					justify-content: flex-start;

					.el-col:first-child {
						margin-right: 30px;
					}
				}
			}
		}
	}

	.channels {
		margin-top: 50px;
	}
}
</style>
